import request from '@utils/request'
import gateway from '@enum/gateway'

// 获取参数
const getAuth = () => {
  return request.post(gateway.auth + '/v1/basic/captcha/create', null, true)
}
// 组织架构树
const getOrganizeTree = () => {
  return request.fetch(gateway.auth + '/v1/basic/organization/tree')
}
// 编辑组织架构树
const updataOrganizeTree = params => {
  return request.put(gateway.auth + '/v1/basic/organization', params)
}
// 新建组织架构树
const addOrganizeTree = params => {
  return request.post(gateway.auth + '/v1/basic/organization', params)
}
// 删除组织架构树
const deleteOrganizeTree = params => {
  return request.delete(gateway.auth + '/v1/basic/organization/{id}', params)
}
// 组织架构树所有子节点
const getOrganizeChild = params => {
  return request.fetch(gateway.auth + '/v1/basic/organization/children', params)
}
// 权限名称
const getAuthNames = params => {
  return request.fetch(gateway.auth + '/v1/basic/employee/resNames', params)
}
// 查询员工
const getPersonInfo = params => {
  return request.fetch(gateway.auth + '/v1/basic/employee', params)
}
// 新建员工
const newPersonModal = params => {
  return request.post(gateway.auth + '/v1/basic/employee', params)
}
// 编辑员工
const updatePersonModal = params => {
  return request.put(gateway.auth + '/v1/basic/employee', params)
}
// 修改密码
const resetPassword = params => {
  return request.formData(gateway.auth + '/v1/basic/changeEmpPwd', params)
}
// 新建权限保存
const newAuthModal = params => {
  return request.post(gateway.auth + '/v1/basic/emp-res-link/link', params)
}
// 编辑权限保存
const updateAuthModal = params => {
  return request.put(gateway.auth + '/v1/basic/emp-res-link/link', params)
}
// 获取员工id
const getEmployeeIdModal = params => {
  return request.fetch(
    gateway.auth + '/v1/basic/emp-res-link/employeeId',
    params
  )
}

// 获取角色
const getRoleList = () => {
  return request.fetch(gateway.essentialService + '/v1/api/role/')
}
// 删除员工
const deletePersonModal = params => {
  return request.post(gateway.auth + '/v1/basic/employees/delete', params)
}
// 获取权限树
const getResponsibilityTree = params => {
  return request.fetch(gateway.essentialService + '/v1/api/role/{id}', params)
}
// 获取全局权限
const getResponsibilityGlobal = params => {
  return request.fetch(gateway.auth + '/v1/basic/data/auth/global', params)
}
// 获取全局权限
const getAuthList = params => {
  return request.fetch(gateway.auth + '/v1/basic/data/auth/list', params)
}
// 获取数据权限详情
const getAuthDetail = params => {
  return request.fetch(gateway.auth + '/v1/basic/data/auth/detail', params)
}
// 获取数据权限详情
const getAuthConfig = params => {
  return request.fetch(
    gateway.auth + '/v1/basic/data/auth/configurations',
    params
  )
}
// 获取组织架构权限列表
const getAuthOrganization = params => {
  return request.fetch(
    gateway.auth + '/v1/basic/res/setting/resOrgLinks/queryByResId',
    params
  )
}
// 获取登录权限列表
const getResLogin = params => {
  return request.fetch(gateway.auth + '/v1/basic/res/screen/resId', params)
}
// 保存权限
const saveResponsibility = params => {
  return request.post(
    gateway.essentialService + '/v1/api/role/association',
    params
  )
}
// 新增角色
const newResponsibility = params => {
  return request.post(gateway.essentialService + '/v1/api/role/', params)
}
// 复制权限
const copyResponsibility = params => {
  return request.post(
    gateway.essentialService + '/v1/api/role/duplicate',
    params
  )
}
// 删除角色
const deleteResponsibility = params => {
  return request.delete(gateway.essentialService + '/v1/api/role/{id}', params)
}
// 修改角色名称
const updateResponsibility = params => {
  return request.put(gateway.essentialService + '/v1/api/role/', params)
}
// 获取所有数据权限明细列表
const getAllResList = params => {
  return request.fetch(gateway.auth + '/v1/basic/data/auth/new/list', params)
}

// 获取所有视图权限
const getAllAuthCodes = params => {
  return request.fetch(gateway.auth + '/v1/basic/view/auth')
}
// 通过手机号获取租户id
const getTenantIdByPhone = params => {
  return request.request({
    method: 'post',
    url: gateway.tenant + '/v1/basic/tenant/register/domain/phone',
    params: params,
    headers: {
      authorize: true
    }
  })
}
// 重置密码获取验证码
const getRestPwdPhoneCode = params => {
  return request.request({
    method: 'post',
    url: gateway.auth + '/v1/basic/captcha/getRestPwdPhoneCode',
    params: params,
    headers: {
      authorize: true
    }
  })
}
const resetEmpPwd = params => {
  return request.request({
    method: 'post',
    url: gateway.auth + '/v1/basic/captcha/resetEmpPwd',
    params: params,
    headers: {
      authorize: true
    }
  })
}

export const getAllResponsibilitys = getRoleList

export {
  getAuth,
  getOrganizeTree,
  getOrganizeChild,
  getAuthNames,
  updataOrganizeTree,
  addOrganizeTree,
  deleteOrganizeTree,
  getPersonInfo,
  resetPassword,
  newPersonModal,
  getEmployeeIdModal,
  getRoleList,
  updatePersonModal,
  newAuthModal,
  updateAuthModal,
  deletePersonModal,
  getResponsibilityTree,
  getResponsibilityGlobal,
  getAuthList,
  getAuthDetail,
  getAuthConfig,
  getAuthOrganization,
  getResLogin,
  saveResponsibility,
  newResponsibility,
  deleteResponsibility,
  copyResponsibility,
  getAllResList,
  getAllAuthCodes,
  getTenantIdByPhone,
  getRestPwdPhoneCode,
  resetEmpPwd,
  updateResponsibility
}
